var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 29.3353C8.63573 29.3353 2.66638 23.366 2.66638 16.002C2.66638 8.63803 8.63573 2.6687 15.9997 2.6687C23.3637 2.6687 29.3331 8.63803 29.3331 16.002C29.3331 23.366 23.3637 29.3353 15.9997 29.3353ZM14.6664 14.6687V22.6687H17.3331V14.6687H14.6664ZM14.6664 9.33537V12.002H17.3331V9.33537H14.6664Z",
    fill: "#FF6624"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFill);
export default __webpack_public_path__ + "static/media/information-fill.0bf472b5d6ba7eb2997957e213d94748.svg";
export { ForwardRef as ReactComponent };